import { Action } from '@ngrx/store';
import { LoggedInUserInformation } from './loggedinuser-information.model';


export const Add_LoggedInUserInformation = 'Add LoggedInUser Information';


export class AddLoggedInUserInformation implements Action {
    readonly type = Add_LoggedInUserInformation;

    constructor(public payload: LoggedInUserInformation ) {}
}


export type LoggedInUserInformationActions =
| AddLoggedInUserInformation;
